import api from 'api'
import {
  ADVISOR_CLIENT_RECEIVED,
  ADVISOR_CLIENT_PATCHED,
  ADVISOR_CLIENT_RESTOREPOINT,
  ADVISOR_CLIENT_CLOSED
} from './types'
import { unloadData } from '../../unloaddata'
import { unloadClientPlans } from '../plans/action'

// redux actions

export const clientReceived = client => ({
  type: ADVISOR_CLIENT_RECEIVED,
  data: client
})
export const clientPatched = client => ({
  type: ADVISOR_CLIENT_PATCHED,
  data: client
})

export const clientClosed = () => ({
  type: ADVISOR_CLIENT_CLOSED
})

export const clientRestorePoint = restorePoint => ({
  type: ADVISOR_CLIENT_RESTOREPOINT,
  data: restorePoint
})

// thunk actions
export const getClient = () => dispatch => 
  api.bmc.advisor.getClient().then(client => {
    client.lastPushToClientAssessment = !client.lastPushToClientAssessment ? {} : JSON.parse(client.lastPushToClientAssessment)
    dispatch(clientReceived(client))
  })

export const getViewProspect = () => dispatch => 
  api.rnc.advisor.getViewProspect().then(client => {
    dispatch(clientReceived(client))
  })
  
export const getClientRestorePoint = () => dispatch => 
  api.bmc.advisor.getClientRestorePoint().then(restorePoint => {
     dispatch(clientRestorePoint(restorePoint))
  })

export const postBeneficiary = data => dispatch =>
  api.bmc.user.postPerson(data).then(person=>{
    dispatch(getClient())
    return person
  })

export const deleteBeneficiary = data => dispatch =>
  api.bmc.user.deletePerson(data).then( person =>{
    dispatch(getClient())
  })

  export const postClient = data => dispatch =>
  api.bmc.advisor.postClient(data.client).then(client=> {
    dispatch(clientReceived(client))
    return client
  })

  export const patchClient = data => dispatch =>
    api.bmc.advisor.patchClient(data).then(client=> {
      dispatch(clientPatched(client))
    })
  
export const closeClient = () => dispatch => 
  api.bmc.advisor.closeClient().then(() => {
    dispatch(clientClosed())
    dispatch(unloadClientPlans())
    dispatch(unloadData())
  })